import { useEffect } from 'react';

import IntegrationSingle from '../Components/IntegrationSingle';


const services = [
  {
    id: 'microsoft',
    name: 'Outlook',
    image: 'outlook.png',
    imageHeight: '70px',
    databaseId: 8, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'oauth',
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a href="https://medicareprocrm.frontkb.com/en/categories/617729" target="_blank">
            Outlook Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'thanksio',
    name: 'Thanks.io',
    image: 'thanksio.png',
    imageHeight: '70px',
    databaseId: 11, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'oauth',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a href="https://medicareprocrm.frontkb.com/en/categories/617601" target="_blank">
            thanks.io Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'retireflo',
    name: 'RetireFlo',
    image: 'retireflo.png',
    imageHeight: '85px',
    databaseId: 29, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'externalOAuthApp',
    html: (
      <>
        <button className="btn btn-primary mb-4 ml-1 text-white">
          <a href="https://app.retireflo.com" target="_blank" className="text-white">
            Connect from RetireFlo
          </a>
        </button>
      </>
    ),
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
  },
  {
    id: 'agentmethods',
    name: 'AgentMethods',
    image: 'agentmethods.png',
    imageHeight: '150px',
    databaseId: 14, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'externalOAuthApp',
    html: (
      <>
        <button className="btn btn-primary mb-4 ml-1 text-white">
          <a href="https://www.agentmethods.com" target="_blank" className="text-white">
            Connect from AgentMethods
          </a>
        </button>
      </>
    ),
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
  },
  {
    id: 'mailchimp',
    name: 'MailChimp',
    image: 'mailchimp.png',
    imageHeight: '90px',
    databaseId: 12, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'oauth',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a
            href="https://medicareprocrm.frontkb.com/en/categories/617793-mailchimp"
            target="_blank"
          >
            Mailchimp Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'constantcontact',
    name: 'ConstantContact',
    image: 'constantcontact.png',
    imageHeight: '75px',
    databaseId: 13, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'oauth',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a
            href="https://medicareprocrm.frontkb.com/en/categories/617985-constantcontact"
            target="_blank"
          >
            ConstantContact Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'aweber',
    name: 'AWeber',
    image: 'aweber.png',
    imageHeight: '110px',
    databaseId: 7, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'oauth',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a href="https://medicareprocrm.frontkb.com/en/categories/616513-aweber" target="_blank">
            AWeber Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'mailboxPower',
    name: 'Mailbox Power',
    image: 'mailboxPower.png',
    imageHeight: '130px',
    databaseId: 5, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'pat',
    external: true,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a
            href="https://medicareprocrm.frontkb.com/en/categories/617857-mailbox-power"
            target="_blank"
          >
            Mailbox Power Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'directmailmanager',
    name: 'Direct Mail Manager',
    image: 'directMail.png',
    imageHeight: '75px',
    databaseId: 7, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'pat',
    external: true,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a
            href="https://medicareprocrm.frontkb.com/en/categories/618753-direct-mail-manager"
            target="_blank"
          >
            DMM Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'currentClient',
    name: 'CurrentClient',
    image: 'currentClient.svg',
    imageHeight: '55px',
    databaseId: 8, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'pat',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    htmlInnerSuffix: (
      <>
        <br />
        <div>
          <a
            href="https://medicareprocrm.frontkb.com/en/categories/618625-currentclient"
            target="_blank"
          >
            CurrentClient Help Guide
          </a>
        </div>
      </>
    ),
  },
  {
    id: 'carecycle',
    name: 'CareCycle',
    image: 'carecycle.png',
    imageHeight: '65px',
    databaseId: 30, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'pat',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
  },
  /*{
        id: 'medizues',
        name: 'MediZues',
        image: 'medizues.png',
        imageHeight: '55px',
        databaseId: 17, // This should not be needed as the 'id' is sufficient but the API needs the database ID
        active: true,
        syncContacts: false,
        agencyAccount: false,
        saveWebhookUrls: true,
        displayIncomingWebhookUrl: true,
        type: 'pat',
        external: true,
        username: false, 
        password: false,
        accountId: false,
        accoundIdName : null,
        htmlInnerSuffix: <>
            <br />
            <div><a href="https://help.medicareproapp.com/kb/en/medizues-406068" target="_blank">MediZues Help Guide</a></div>
        </>
    },*/
  {
    id: 'slybroadcast',
    name: 'SlyBroadcast',
    image: 'slybroadcast.png',
    imageHeight: '75px',
    databaseId: 20, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    saveWebhookUrls: false,
    type: 'pat',
    external: true,
    username: true,
    password: true,
    accountId: true,
    accoundIdName: 'Phone Number'
  },
  {
    id: 'enrollhere',
    name: 'EnrollHere',
    image: 'enrollhere.png',
    imageHeight: '75px',
    databaseId: 33, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: true,
    agencyAccount: false,
    saveWebhookUrls: false,
    type: 'pat',
    external: true,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null
  },
  {
    id: 'simpletexting',
    name: 'SimpleTexting',
    image: 'simpletexting.png',
    imageHeight: '50px',
    databaseId: 34, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    type: 'pat',
    external: true,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null
  },
  {
    id: 'textrequest',
    name: 'TextRequest',
    image: 'textrequest.png',
    imageHeight: '50px',
    databaseId: 39, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: true,
    type: 'pat',
    external: true,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null,
    fetchAccountIdOptions: true
  },
  {
    id: 'twilio',
    name: 'Twilio',
    image: 'twilio.png',
    imageHeight: '100px',
    databaseId: 43, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    agencyAccount: false,
    type: 'pat',
    external: true,
    fetchAccountIdOptions: true,
    component: true,
    htmlInnerSuffix: <>
      <br />
      <div><a href="https://help.medicareproapp.com/en/articles/9870017" target="_blank">Twilio Help Guide</a></div>
    </>
  },
  {
    id: 'medicareagentshub',
    name: 'Medicare Agents Hub',
    image: 'medicareagentshub.png',
    imageHeight: '70px',
    databaseId: 37, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    saveWebhookUrls: false,
    displayIncomingWebhookUrl: true,
    generateIncomingWebhookUrlOnSetup: true,
    type: 'pat',
    external: false,
    username: false,
    password: false,
    accountId: false,
    accoundIdName: null
  },
  {
    id: 'optimizead',
    name: 'Optimize.Ad',
    image: 'optimizead.png',
    imageHeight: '30',
    databaseId: 42, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: false,
    saveWebhookUrls: false,
    displayIncomingWebhookUrl: true,
    type: 'pat',
    external: false,
    username: false,
    password: false,
    accountId: false
  },
  {
    id: 'healthsherpamedicare',
    name: 'HealthSherpa Medicare',
    image: 'healthsherpamedicare.png',
    imageHeight: '25px',
    databaseId: 38, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: false,
    agencyAccount: true,
    type: 'pat',
    external: true,
    username: true,
    usernameName: "Health Sherpa username (email address)",
    password: false,
    accountId: false,
    accoundIdName: null,
    fetchAccountIdOptions: true,
    htmlInnerSuffix: <>
      <br />
      <div className="alert alert-primary small text-dark text-left"><div><b>Individual Agents: </b>Connect your HealthSherpa Medicare account here</div><div><b>Agencies: </b>If you want to set this up for you and your downline agents, go to the Agency Integrations page.</div><div className="mt-2"><a className="font-weight-bold" target="_blank" href="https://help.medicareproapp.com/en/categories/1744897">Learn more</a> about the HealthSherpa Medicare Integration.</div></div>
    </>
  }
];

export default function AgentIntegrationPanel(props) {
  const allowedIntegrationServices = props.allowedIntegrationServices || [];
  console.log('allowed int services: ', allowedIntegrationServices);
  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  var userRepository = new MedicareProAPI.UserRepository();
  userRepository.setAccessToken(props.userAccessToken);

  var userIntegrationOAuthRepository = new MedicareProAPI.UserIntegrationOAuthRepository();
  userIntegrationOAuthRepository.setAccessToken(props.userAccessToken);

  var userPersonalTokenRepository = new MedicareProAPI.UserPersonalTokenRepository();
  userPersonalTokenRepository.setAccessToken(props.userAccessToken);

  var individualRepository = new MedicareProAPI.IndRepository();
  individualRepository.setAccessToken(props.userAccessToken);

  var individualAlternateIdRepository = new MedicareProAPI.IndAlternateIdRepository();
  individualAlternateIdRepository.setAccessToken(props.userAccessToken);

  const filteredServices =
    props?.allowedIntegrationServices?.length > 0
      ? services.filter((service) => props.allowedIntegrationServices.includes(service.id))
      : services;

  console.log('integration panel services: ', filteredServices);
  // 1 = Andrew live account
  // 100 = local account / no live account for 100
  // 847 = Matt live account
  // 3338 = Google Developer live account
  var gmailAccess = ['1', '100', '847', '3338'];

  if (gmailAccess.includes(props.userId)) {
    services.unshift({
      id: 'google',
      name: 'Google',
      image: 'google.webp',
      imageHeight: '70px',
      databaseId: 10, // This should not be needed as the 'id' is sufficient but the API needs the database ID
      active: true,
      syncContacts: false,
      agencyAccount: false,
      customBranding: true,
      connectLabel: 'Sign in with Google',
      reconnectLabel: 'Sign back in with Google',
      type: 'oauth',
      htmlInnerSuffix: (
        <p className="mt-4 small">
          MedicarePRO's use and transfer of information received from Google APIs to any other app
          will adhere to{' '}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
            target="_blank"
          >
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements.
        </p>
      ),
    });
  }

  // Check which services are connected
  useEffect(() => { }, []);

  return (
    <>
      <div className="row">
        {filteredServices.map((service) => {
          return (
            <IntegrationSingle
              service={service}
              userId={props.userId}
              agencyId={props.agencyId}
              userAccessToken={props.userAccessToken}
              renderedExternal={props.renderedExternal}
            />
          );
        })}
      </div>
    </>
  );
}
